/**
 * Task status constants for media processing states.
 */

export enum TaskStatus {
  PENDING = "pending",
  IN_PROGRESS = "in_progress",
  ADD_TO_TASKS = "add to tasks",
}

export const IN_FLIGHT_STATUSES = new Set<string>(Object.values(TaskStatus));
